import type { Image360ViewedEvent } from './Image360ViewedEvent';
import { image360ViewedSchema } from './Image360ViewedSchema';

type Props = {
  listingId: string;
  userId: string;
};

export const image360ViewedToEvent = ({ listingId, userId }: Props): Image360ViewedEvent => {
  const event: Image360ViewedEvent = {
    schema: image360ViewedSchema.ref,
    data: {
      listing_id: listingId,
      user_id: userId,
    },
  };

  return event;
};
